import React from 'react';
import BlankWidget from './../../components/CategoryListing/Widgets/BlankWidgets';
import Loadable from 'react-loadable';

const CategoryLoadable = Loadable({
    loader: () => import('./Category' /* webpackChunkName: 'category' */).then(module => module.default),
    loading: () => (<div className="redis-loader">
        <div className="filters-navigate default-filters">
            <BlankWidget styleObj="filter-loader" />
        </div>
        <BlankWidget styleObj="category-loader" />
    </div>)
});

export default CategoryLoadable;
